import { KeyValue } from '@delmonicos/shared-design-system-react/src/components/filter-selector/filter-selector';
import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TransactionStateName } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/enums/transaction/transaction-state.enum';
import { useTranslation } from 'react-i18next';

import { mapStateToGenericTransactionState } from '@app/feature/charge-point/helper/transaction-state.helper';

const unfilterableStates = new Set([
  TransactionStateName.REMOTE_START_TRANSACTION_ACCEPTED,
  TransactionStateName.REMOTE_START_TRANSACTION_REFUSED,
  TransactionStateName.REMOTE_STOP_TRANSACTION_ACCEPTED,
  TransactionStateName.REMOTE_STOP_TRANSACTION_REFUSED,
  TransactionStateName.REMOTE_START_TRANSACTION_REQUESTED,
  TransactionStateName.REMOTE_STOP_TRANSACTION_REQUESTED,
]);

interface TransactionStateFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const TransactionStateFilterController = ({
  onChange,
  selectedItemIds,
}: TransactionStateFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const transactionStates = Object.values(TransactionStateName)
    .map((state) => ({
      key: state,
      value: t(`delmonicos-shared-sdk.enums-transaction-state.${state}`),
    }))
    .filter((i) => !unfilterableStates.has(i.key));

  const additionalBackgroundColor = (item: KeyValue) => {
    return mapStateToGenericTransactionState(item.key as TransactionStateName)
      .color;
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="electric-car-2"
        text={t('delmonicos-shared-sdk.outputs-transaction-state.state')}
      />
      <FilterToggle
        initialSelectedItemIds={selectedItemIds}
        items={transactionStates}
        onChange={onChange}
        additionalBackgroundColor={additionalBackgroundColor}
      />
    </Stack>
  );
};
